/* eslint-disable @typescript-eslint/naming-convention */
export class TableConfigurations {
  config: any = {
    defaultActions: {
      delete: { name: 'delete', icon: 'pi-trash', color: 'secondary' },
      edit: { name: 'edit', icon: 'pi-pencil', color: 'primary' },
      unassign: { name: 'unassign', icon: 'pi-times', color: 'primary' },
      view: { name: 'view', icon: 'pi-eye', color: 'tertiary' },
      redirectLink: {
        name: 'redirectLink',
        icon: 'pi-search-plus',
        color: 'primary',
      },
    },
    TerritoryManagementPage: {
      actions: ['unassign', 'redirectLink'],
      globalFilterFields: [],
      columns: [
        {
          label: 'ID',
          field: 'id',
          type: 'text',
          isText: true,
          visible: true,
        },
        {
          label: 'Name',
          field: 'territoryName',
          type: 'text',
          isText: true,
          visible: true,
        },
        {
          label: 'Active',
          field: 'territoryActive',
          type: 'checkbox',
          isCheckbox: true,
          //visible: true,
        },
        {
          label: 'Status',
          field: 'territoryStatus',
          type: 'text',
          isText: true,
          visible: true,
        },
        {
          label: 'Organization',
          field: 'vendorAccountName',
          type: 'text',
          isText: true,
          visible: true,
        },
        {
          label: 'Outlet',
          field: 'vendorGroup',
          type: 'text',
          isText: true,
          visible: true,
        },
        {
          label: 'Campaign Type',
          field: 'territoryType',
          type: 'text',
          isText: true,
          visible: true,
        },
        {
          label: 'Created By',
          field: 'createdBy',
          type: 'text',
          isText: true,
        },
        {
          label: 'Created Date',
          field: 'createdAt',
          type: 'date',
          isDate: true,
        },
        {
          label: 'Progress',
          field: 'progress',
          type: 'text',
          isText: true,
          visible: true,
          disabledSorting: true,
        },
      ],
    },
    TerritoryDetailsPage: {
      actions: ['unassign', 'redirectLink'],
      globalFilterFields: [],
      columns: [
        {
          label: 'ID',
          field: 'id',
          type: 'text',
          visible: false,
        },
        {
          label: 'Pin',
          field: 'walklistPin',
          type: 'text',
          isText: true,
          visible: true,
        },
        {
          label: 'Walklist Name',
          field: 'walklistName',
          type: 'text',
          isText: true,
          visible: true,
        },
        {
          label: 'Stops',
          field: 'stops',
          type: 'text',
          isText: true,
          visible: true,
        },
        {
          label: 'Active',
          field: 'walklistActive',
          type: 'checkbox',
          isCheckbox: true,
          //visible: true,
        },
        {
          label: 'Vendor Sales Rep Name',
          field: 'vendorSalesRepName',
          type: 'text',
          isAssignee: true,
          disabledSorting: true,
          visible: true,
        },
        {
          label: 'Assigned Date',
          field: 'assignedDate',
          type: 'date',
          disabledSorting: true,
          visible: true,
        },
        {
          label: 'Modified At',
          field: 'modifiedAt',
          type: 'date',
          text: true,
        },
        {
          label: 'Completion',
          field: 'completion',
          type: 'text',
          disabledSorting: true,
          operator: '%',
          disabledFilter: true,
          visible: true,
        },
      ],
    },
    WalkListDetailsPage: {
      actions: ['redirectLink'],
      detailsSection: [
        {
          label: 'ID',
          field: 'id',
          type: 'text',
          visible: false,
        },
        {
          title: 'vendorSalesRepName',
          property: 'vendorSalesRepName',
          editType: 'dropdown',
          isEditable: true,
          unnasignable: true,
        },
        {
          title: 'vendorSalesRepName2',
          property: 'vendorSalesRepName2',
          editType: 'dropdown',
          isEditable: false,
          unnasignable: true,
        },
        {
          title: 'detailDescription',
          property: 'walklistDescription',
          editType: 'longtext',
          isEditable: true,
          unnasignable: false,
        },
        {
          title: 'completion',
          property: 'completion',
          editType: 'longtext',
          isEditable: false,
          unnasignable: false,
        },
        {
          title: 'walklistStatus',
          property: 'walklistStatus',
          editType: 'longtext',
          isEditable: false,
          unnasignable: false,
        },
      ],
      globalFilterFields: [],
      columns: [
        {
          label: 'Pin',
          field: 'pin',
          type: 'text',
          isText: true,
          disabledSorting: true,
          visible: true,
        },
        {
          label: 'Address ID',
          field: 'addressId',
          type: 'text',
          isText: true,
          disabledSorting: true,
          visible: false,
        },
        {
          label: 'Address',
          field: 'address',
          type: 'text',
          disabledSorting: true,
          isAddress: true,
          visible: true,
        },
        {
          label: 'Address Geom',
          field: 'addressGeomText',
          type: 'text',
          disabledSorting: true,
          visible: false,
        },
        {
          label: 'Last Knock',
          field: 'lastKnockStatus',
          isLastKnock: true,
          disabledSorting: true,
          visible: true,
        },
        {
          label: 'Street Name',
          field: 'formattedStreetName',
          type: 'text',
          disabledSorting: true,
          visible: false,
        },
        {
          label: 'Street Number',
          field: 'formattedStreetNumber',
          isText: true,
          disabledSorting: true,
          visible: false,
        },
        {
          label: 'Current Tech',
          field: 'currentTechnologyType',
          type: 'object',
          disabledSorting: true,
          visible: false,
        },
        {
          label: 'Avail Tech',
          field: 'availableTechnologyType',
          type: 'object',
          disabledSorting: true,
          visible: false,
        },
        {
          label: 'Existing Products',
          field: 'existingProduct',
          type: 'html',
          isProduct: true,
          disabledSorting: true,
          visible: true,
        },
        {
          label: 'Existing Business Products',
          field: 'existingBusinessProducts',
          type: 'text',
          isText: true,
          disabledSorting: true,
          visible: false,
        },
        {
          label: 'Premise Type',
          field: 'premiseType',
          type: 'text',
          isText: true,
          disabledSorting: true,
          visible: false,
        },
        {
          label: 'City',
          field: 'city',
          type: 'text',
          isText: true,
          disabledSorting: true,
          visible: false,
        },
        {
          label: 'Created By',
          field: 'createdBy',
          type: 'text',
          isDate: true,
          disabledSorting: true,
          visible: false,
        },
        {
          label: 'created At',
          field: 'createdAt',
          type: 'date',
          disabledSorting: true,
          isDate: true,
          visible: false,
        },
      ],
    },
    'Knock-ListPage': {
      actions: ['delete', 'redirectLink'],
      globalFilterFields: [],
      columns: [
        {
          label: 'Knock Status',
          field: 'knockStatus',
          type: 'text',
          text: true,
          visible: true,
        },
        {
          label: 'Knock Type',
          field: 'knockType',
          type: 'text',
          text: true,
          visible: true,
        },
        {
          label: 'Address ID',
          field: 'addressId',
          type: 'text',
          text: true,
          hasRedirectLink: true,
          visible: true,
        },
        {
          label: 'Created At',
          field: 'createdAt',
          type: 'date',
          isText: true,
          visible: true,
        },
        {
          label: 'Created By',
          field: 'createdBy',
          type: 'text',
          isText: true,
          hasRedirectLink: true,
          visible: true,
        },
        {
          label: 'Modified At',
          field: 'modifiedAt',
          type: 'date',
          visible: true,
        },
        {
          label: 'Modified By',
          field: 'modifiedBy',
          type: 'text',
          hasRedirectLink: true,
          visible: true,
        },
      ],
    },
    'Drop-PermissionPage': {
      actions: ['delete', 'redirectLink'],
      globalFilterFields: [],
      columns: [
        {
          label: 'Drop Permission',
          field: 'dropPermissionName',
          type: 'text',
          text: true,
          visible: true,
        },
        {
          label: 'Service Address',
          field: 'addressId',
          type: 'text',
          text: true,
          hasRedirectLink: true,
          visible: true,
        },
        {
          label: 'status',
          field: 'status',
          type: 'text',
          text: true,
          visible: true,
        },
        {
          label: 'Created Date',
          field: 'createdAt',
          type: 'date',
          isDate: true,
          visible: true,
        },
        {
          label: 'Record Type',
          field: 'recordType',
          type: 'text',
          text: true,
          visible: true,
        },
        {
          label: 'Source System',
          field: 'sourceSystem',
          type: 'text',
          text: true,
          visible: true,
          isSystemInfo: true,
        },
        {
          label: 'Created By',
          field: 'createdBy',
          type: 'text',
          isText: true,
          visible: true,
        },
      ],
    },
  };

  public getConfig(): any {
    return this.config;
  }

  public getConfigByPagType(pageType?: string): any {
    return this.config[pageType];
  }

  public getDefaultConfig(): any {
    return {
      isDescOrder: true,
      limit: 100,
      isLoading: false,
      showCurrentPageReport: true,
    };
  }
}
